import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CarRepairDrawer from "./modules/CarRepairDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction } from '@api/manage';
import { queryUserTreeList as _queryUserTreeList } from '@/api/api';
import moment from 'moment';
export default {
  name: 'CarRepairList',
  mixins: [JeecgListMixin],
  components: {
    CarRepairDrawer: CarRepairDrawer
  },
  data: function data() {
    return {
      permissionObj: {
        add: 'car:ea_asset_car_repair:add',
        delete: 'car:ea_asset_car_repair:delete',
        edit: 'car:ea_asset_car_repair:edit',
        deleteBatch: 'car:ea_asset_car_repair:deleteBatch'
      },
      carShow: true,
      pagePath: '/ea/asset/car/repair',
      pageTitle: '车辆维保',
      carList: [],
      model: [],
      //时间差
      autoLoadInit: false,
      userTree: [],
      //人员信息
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'card',
        colName: 'car_id',
        title: '车牌号',
        align: 'center'
      }, {
        dataIndex: 'code',
        colName: 'code',
        title: '维保单号',
        align: 'center'
      }, {
        dataIndex: 'userId_userName',
        colName: 'user_id',
        title: '登记人',
        align: 'center'
      }, {
        dataIndex: 'location',
        colName: 'location',
        title: '维保地址',
        align: 'center'
      }, {
        dataIndex: 'category_dictText',
        colName: 'category',
        title: '维保类别',
        align: 'center'
      }, {
        dataIndex: 'totalKilometers',
        colName: 'totalKilometers',
        title: '维保总公里',
        align: 'center'
      }, {
        dataIndex: 'fee',
        colName: 'fee',
        title: '维保自费金额',
        align: 'center'
      }, {
        dataIndex: 'sdate',
        colName: 'sdate',
        title: '维保开始时间',
        align: 'center'
      }, {
        dataIndex: 'edate',
        colName: 'edate',
        title: '维保结束时间',
        align: 'center'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      url: {
        carList: '/ea/asset/car/queryCarCards'
      },
      keys: [],
      roleList: '',
      addTime: '',
      buTime: '',
      siteName: '',
      queryParam: {
        column: 'create_time',
        order: 'desc'
      }
    };
  },
  props: {
    carId: {
      type: Number,
      default: null
    },
    carDetails: Boolean
  },
  created: function created() {
    if (this.carDetails) {
      this.queryParam.carId = this.carId;
      this.carShow = !this.carDetails;
    }

    this.queryUserTreeList();
    this.queryCarList();
    this.model = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
    this.keys = JSON.parse(window.localStorage.getItem('pro__Login_Userinfo'));
    this.loadData();
  },
  computed: {},
  methods: {
    onDateSdate: function onDateSdate(value, dateArray) {
      this.queryParam.stime = dateArray[0];
      this.queryParam.etime = dateArray[1];
    },
    getAuth: function getAuth(id) {
      if (this.$store.getters.userInfo.roleList.includes('administrator') || this.$store.getters.userInfo.roleList.includes('tenant_admin')) {
        return true;
      } else {
        return id == this.$store.getters.userInfo.id && this.buTime - this.addTime < 60 * 60 * 1000;
      }
    },
    searchReset: function searchReset() {
      this.queryParam = {
        column: 'create_time',
        order: 'desc',
        carId: this.carId
      };
      this.dates = {};
      this.loadData(1);
    },
    //查询
    searchQuery: function searchQuery() {
      if (this.$refs.page) {
        this.$refs.page.resetPage();
      } else {
        this.loadData(1);
      }
    },
    modalFormOk: function modalFormOk() {
      this.queryParam = {
        carId: this.carId
      };
      this.loadData(1);
    },
    queryCarList: function queryCarList() {
      var that = this;
      that.carList = [];
      getAction(that.url.carList).then(function (res) {
        if (res.success) {
          that.carList = res.result;
        }
      });
    },
    queryUserTreeList: function queryUserTreeList() {
      var _this = this;

      var that = this;
      that.userTree = []; // 用户

      _queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this.loading = false;
        }
      });
    },
    handleAdd: function handleAdd() {
      if (this.carId != null) {
        this.$refs.modalForm.add(this.carId);
      } else {
        this.$refs.modalForm.add();
      }

      this.$refs.modalForm.title = '新增：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = false;
      this.$refs.modalForm.showContact = false;
    },
    handleDetail: function handleDetail(record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = this.pageTitle + '详情';
      this.$refs.modalForm.disableSubmit = true;
      this.$refs.modalForm.disableStatus = true;
      this.$refs.modalForm.showTab = true;
      this.$refs.modalForm.showContact = false;
    },
    handleEdit: function handleEdit(record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '编辑：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;

      if (this.carId != null) {
        this.$refs.modalForm.disableStatus = true;
      } else {
        this.$refs.modalForm.disableStatus = false;
      }

      this.$refs.modalForm.showTab = true;
      this.$refs.modalForm.showContact = true;
    },
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};